import OrderTrakingScreen from './OrderTrakingScreen'

export default OrderTrakingScreen
